class ReelsSlider extends HTMLElement {
  constructor() {
    super();
    this.swiperElement = this.querySelector(".swiper");
    this.nextElement = this.querySelector(".swiper-button-next");
    this.prevElement = this.querySelector(".swiper-button-prev");
    this.slides = this.swiperElement.querySelectorAll(".swiper-slide");
  }
  connectedCallback() {
    this.initSlider();
    this.slides.forEach((slide) =>
      slide.addEventListener("click", (e) => {
        this.openPopup(e.target.closest(".swiper-slide"));
      })
    );
  }
  initSlider() {
    this.swiper = new Swiper(this.swiperElement, {
      slidesPerView: 3,
      spaceBetween: 9,
      breakpoints: {
        1100: {
          spaceBetween: 12,
        },
      },
      navigation: {
        nextEl: this.nextElement,
        prevEl: this.prevElement,
      },
    });
  }
  openPopup(slide) {
    document.dispatchEvent(
      new CustomEvent("openPopup", {
        detail: slide,
      })
    );
  }
}

customElements.define("reels-slider", ReelsSlider);

class ReelsPopup extends HTMLElement {
  constructor() {
    super();
    this.swiperElement = this.querySelector(".swiper");
    this.slides = this.swiperElement.querySelectorAll(".swiper-slide");
    this.videos = this.swiperElement.querySelectorAll("video");
    this.closeBtn = this.querySelector(".close");
    this.muteBtn = this.querySelector(".mute");
    this.mute = false;
    this.pauseBtn = this.querySelector(".pause");
    this.pause = false;
    this.isAutoSwipe = false;
  }
  connectedCallback() {
    this.initSlider();
    document.addEventListener("openPopup", (e) => {
      this.openPopup(e.detail);
    });
    this.slides.forEach((slide) => {
      slide.addEventListener("click", (e) => {
        this.toSlide(e.target.closest(".swiper-slide"));
      });
    });
    this.closeBtn.addEventListener("click", () => {
      this.closePopup();
    });
    this.videos.forEach((video) => {
      video.addEventListener("error", (e) => {
        console.log("Video error:", e);
        // Maybe try to reload the video
        video.load();
      });

      video.addEventListener("ended", () => {
        this.querySelectorAll(".progress-bar--container").forEach(
          (container) => {
            container.style.display = "none";
          }
        );
        this.isAutoSwipe = true;
        this.swiper.slideNext();
        this.currentSlide = Array.from(this.slides).find((itemSlide) => {
          return itemSlide.dataset.index == this.swiper.activeIndex;
        });
        this.playVideo(this.currentSlide);
      });
      video.addEventListener("timeupdate", () => {
        let progress = (video.currentTime / video.duration) * 100;
        this.progressBar.style.width = progress + "%";
      });
    });
    this.muteBtn.addEventListener("click", () => {
      this.muteVideo();
    });
    this.pauseBtn.addEventListener("click", () => {
      if (!this.pause) {
        this.stopVideo();
      } else {
        this.playVideo(this.swiper.slides[this.swiper.activeIndex], true);
      }
    });
    this.swiper.on("slideChange", () => {
      if (this.swiper.swipeDirection && !this.isAutoSwipe) {
        setTimeout(() => {
          this.currentSlide = Array.from(this.slides).find((itemSlide) => {
            return itemSlide.dataset.index == this.swiper.activeIndex;
          });
          this.playVideo(this.currentSlide);
        }, 50); // Small delay to ensure transition is complete
      } else {
        this.isAutoSwipe = false;
      }
    });
  }
  initSlider() {
    this.swiper = new Swiper(this.swiperElement, {
      slidesPerView: 1,
      spaceBetween: 9,
      rewind: true,
      watchSlidesProgress: true,
      preloadImages: true,
      lazy: {
        loadPrevNext: true,
      },
      speed: 300,
      on: {
        beforeTransitionStart: function () {
          // Ensure next slide's video is ready
          const nextSlide = this.slides[this.activeIndex];
          if (nextSlide) {
            const video = nextSlide.querySelector("video");
            if (video) video.load();
          }
        },
      },
      centeredSlides: true,
      allowTouchMove: true,
      breakpoints: {
        429: {
          slidesPerView: 2,
          spaceBetween: 9,
        },
        800: {
          slidesPerView: 3,
          spaceBetween: 30,
          allowTouchMove: false,
        },
        1100: {
          slidesPerView: 4,
          spaceBetween: 44,
          allowTouchMove: false,
        },
        1800: {
          slidesPerView: 5,
          spaceBetween: 0,
          allowTouchMove: false,
        },
      },
    });
  }
  openPopup(slide) {
    this.style.display = "block";
    document.body.style.overflow = "hidden";

    // Preload all videos explicitly
    this.videos.forEach((video) => {
      video.preload = "auto";
      // Try to load video data
      video.load();
    });

    this.toSlide(slide);
  }
  toSlide(slide) {
    if (this.swiper.slides[this.swiper.activeIndex] != slide) {
      this.querySelectorAll(".progress-bar--container").forEach((container) => {
        container.style.display = "none";
      });
      this.swiper.slideTo(slide.dataset.index);
      this.currentSlide = Array.from(this.slides).find((itemSlide) => {
        return itemSlide.dataset.index == slide.dataset.index;
      });
      this.progressBar = this.currentSlide.querySelector(".progress-bar");
      this.playVideo(this.currentSlide);
    }
  }
  playVideo(slide, isCurrentVideo) {
    if (!isCurrentVideo) {
      this.stopAllVideo();
    }

    this.progressBar = this.currentSlide.querySelector(".progress-bar");
    this.currentSlide.querySelector(".progress-bar--container").style.display =
      "block";
    this.pause = false;

    const video = slide.querySelector("video");
    video.muted = this.mute;

    // Reset video if it ended
    if (video.ended) {
      video.currentTime = 0;
    }

    // Use play() as a promise
    const playPromise = video.play();
    if (playPromise !== undefined) {
      playPromise
        .then(() => {
          this.pauseBtn.querySelector(".stop").style.display = "block";
          this.pauseBtn.querySelector(".play").style.display = "none";
        })
        .catch((error) => {
          console.log("Video play failed:", error);
          // Maybe try to play again after a short delay
          setTimeout(() => video.play(), 100);
        });
    }
  }
  stopAllVideo() {
    this.videos.forEach((video) => {
      video.currentTime = 0;
      video.pause();
    });
  }
  closePopup() {
    this.stopAllVideo();
    this.style.display = "none";
    document.body.style.overflow = "auto";
  }
  muteVideo() {
    this.mute = !this.mute;
    if (!this.mute) {
      this.muteBtn.querySelector(".speaker-high").style.display = "block";
      this.muteBtn.querySelector(".speaker-slash").style.display = "none";
    } else {
      this.muteBtn.querySelector(".speaker-high").style.display = "none";
      this.muteBtn.querySelector(".speaker-slash").style.display = "block";
    }
    this.swiper.slides[this.swiper.activeIndex].querySelector("video").muted =
      this.mute;
  }
  stopVideo() {
    this.pause = true;
    this.pauseBtn.querySelector(".stop").style.display = "none";
    this.pauseBtn.querySelector(".play").style.display = "block";
    this.swiper.slides[this.swiper.activeIndex].querySelector("video").pause();
  }
}

customElements.define("reels-popup", ReelsPopup);
